import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPersonShelter } from '@fortawesome/free-solid-svg-icons'
import { faBed } from '@fortawesome/free-solid-svg-icons'
import { faBath } from '@fortawesome/free-solid-svg-icons'
import { faSackDollar } from '@fortawesome/free-solid-svg-icons'

const Properties = ({ele, it}) => {
  const [isVisible, setIsVisible] = useState(false);
  const missionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (missionRef.current) {
      observer.observe(missionRef.current);
    }

  }, [missionRef]);

  return (
    <div
      ref={missionRef}
      key={it}
      className={`w-full flex flex-col justify-between bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 p-4 ${isVisible ? 'animate-slideInTop1 opacity-100' : 'opacity-0'}`}
    >
      <div>
        <div className="overflow-hidden rounded-md mb-4 bg-gray-100">
          <img
            loading="lazy"
            decoding="async"
            src={ele.image}
            alt={ele.name}
            srcSet={ele.srcSet}
            sizes="(max-width: 600px) 400px, (max-width: 1200px) 800px, 1200px"
            className='w-full h-48 sm:h-56 md:h-60 object-cover hover:scale-105 transition-transform duration-500'
          />
        </div>
        <h2 className='text-lg sm:text-xl font-bold text-gray-900'>{ele.name}</h2>
        <h3 className='text-xs sm:text-sm my-2 text-gray-600'>{ele.location}</h3>
      </div>
      <div className='flex flex-wrap items-center justify-between gap-2 pt-3 border-t border-gray-100 text-xs sm:text-sm text-gray-700 mt-2'>
        <p className='flex items-center'><FontAwesomeIcon className="mr-1.5 text-bluColor" icon={faPersonShelter} />{ele.area}</p>
        <p className='flex items-center'><FontAwesomeIcon className="mr-1.5 text-bluColor" icon={faBed} /> {ele.rooms}</p>
        <p className='flex items-center'><FontAwesomeIcon className="mr-1.5 text-bluColor" icon={faBath} />{ele.bathroom}</p>
        <p className='flex items-center font-semibold text-gray-900'><FontAwesomeIcon className="mr-1.5 text-bluColor" icon={faSackDollar} />{ele.price}</p>
      </div>
    </div>
  );
};

export default Properties;
